
import { Avatar, Box, Chip, Flex, Typography } from "../../../../ppui";

export const headers = (currentPage, rowsPerPage) => [
  {
    key: "slNo",
    label: "SL No.",
    isShortable: true,
    isVisible: true,
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "name",
    label: "Employee Name",
    isClickable: true,
    isShortable: true,
    isVisible: true,
    isColumnSticky: true,
    getValue: (row) => (
      <Flex alignItems="center">
        <Avatar
          className={"avatarHover"}
          size="sm"
          initials={`${row?.employees?.first_name.trim().substring(0, 1).toUpperCase()}${row?.employees?.last_name.trim().substring(0, 1).toUpperCase()}`}
          color="secondary"
          sx={{ marginInlineEnd: "0.625rem" }}
        />
        <Box>
          {row?.employees?.full_name}
          <br />
          <Typography
            color={"default"}
            colorVariant={"light"}
            variant={"body2"}
            mb={"0"}
          >
            {" "}
            #{row?.employees?.employee_code}
          </Typography>
        </Box>
      </Flex>
    ),
  },
  {
    key: "department",
    label: "Department",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row?.employees?.departments?.dept_name?row?.employees?.departments?.dept_name:'--',
  },
  {
    key: "designation",
    label: "Designation",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row?.employees?.designations?.designation_name?row?.employees?.designations?.designation_name:'--',
  },
  {
    key: "days",
    label: "Days",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row?.leave_days?row?.leave_days:'--',
  },
  {
    key: "status",
    label: "Status",
    align: "left",
    isClickable: false,
    isShortable: true,
    isVisible: true,
    getValue: (row) => (
      <Chip
        color={
          row.status === "approved"
            ? "success"
            : row.status === "rejected"
            ? "danger"
            : "warning"
        }
        label={row?.status ? row?.status : "--"}
        variant="filled"
        noHover
        dot
        sx={{ textTransform: "capitalize" }}
      />
    ),
  },
  {
    key: "reason",
    label: "Reason",
    align: "left",
    isShortable: true,
    isVisible: true,
    getValue: (row) => row?.reason || "--",
  },
];

